import {
  Facebook,
  Instagram,
  LinkedIn,
  CheckCircle,
  RadioButtonUnchecked,
  Edit,
  LocationOn,
  Link,
  Delete,
  OpenInNew,
  AccountBalance,
} from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Box,
  Chip,
  Typography,
  Card,
  CardContent,
  LinearProgress,
  IconButton,
} from "@mui/material";
import _, {  isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import useStyles from "./styles";
import {
  getAPIProgressData,
  getApiData,
  getApiDataWith403Handling,
} from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import PlaceAutoComplete from "../../components/PlaceAutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import color from "../../config/theme";
import authActions from "../../redux/reducers/auth/actions";
import { updateStepMappingToCompleted } from "../../utils/stepMappingUtils";
import ConfirmModel from "../../components/ConfirmModel";
import MapsView from "../NewProjectDetails/components/ProjectOverview/MapsView";
import PortfolioPreview from "../../components/PortfolioPreview";
import SocialProfilesModal from "../../components/SocialProfilesModal";
import BillingInformationModal from "../../components/BillingInformationModal";
import ExpertiseSelectionModal from "../../components/ExpertiseSelectionModal";


const errorObj = {
  expertiseErr: false,
  expertiseMsg: "",
};


export default function EditProfile({ onTabChange, readOnly = false }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { token, userData, onboardingDismissedByUser } = useSelector((state) => state.auth);
  const onboardingDismissed = userData?.id ? onboardingDismissedByUser?.[userData.id] : false;
  const dispatch = useDispatch();
  const { setUserData, setAccountTab, setOnboardingDismissed } = authActions;

  const fileInputRef = useRef();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [pageLoad, setPageLoad] = useState(true);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [userLocation, setUserLocation] = useState("");
  const [bLogo, setBLogo] = useState(null);
  const [expertiseList, setExpertiseList] = useState([]);
  const [errObj, setErrObj] = useState(errorObj);
  const data = profileData?.contractor_data;
  const isEdit = !isEmpty(profileData);
  const [state, setState] = useState({
    businessLogo: "",
    cname: "",
    description: "",
    address: "",
    email: "",
    website: "",
    phone: "",
    countryCode: "",
    pCode: "",
    businessYear: "",
    employees: "",
    annualContract: "",
    expertise: [],
    expertiseIds: [],
    certificate: [],
    license: [],
    registraion: [],
    linkedin: "",
    social: "",
    insta: "",
    portfolio: [],
    projects_key_locations: "",
  });
  const [deleteImg, setDeleteImg] = useState({
    visible: false,
    id: null,
    index: null,
    type: "",
    loader: false,
  });
  const [socialModalOpen, setSocialModalOpen] = useState(false);
  const [billingModalOpen, setBillingModalOpen] = useState(false);
  const [expertiseModalOpen, setExpertiseModalOpen] = useState(false);
  const [editingDescription, setEditingDescription] = useState(false);
  const [tempDescription, setTempDescription] = useState("");
  const [editingLocation, setEditingLocation] = useState(false);
  const [tempLocation, setTempLocation] = useState(null);
  const [workflowSteps, setWorkflowSteps] = useState([]);
  const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);


  useEffect(() => {
    getProjectList();
    getUserDetailsByIdApiCall();
  }, []);

  // Fetch workflow steps when userData.id becomes available
  useEffect(() => {
    if (userData?.id) {
      fetchWorkflowSteps();
    }
  }, [userData?.id]);

  // Listen for workflow steps updates from other components
  useEffect(() => {
    const handleWorkflowStepsUpdated = () => {
      fetchWorkflowSteps();
    };

    window.addEventListener('workflowStepsUpdated', handleWorkflowStepsUpdated);
    
    return () => {
      window.removeEventListener('workflowStepsUpdated', handleWorkflowStepsUpdated);
    };
  }, [userData?.id, token]);

  const fetchWorkflowSteps = async () => {
    try {
      const refId = userData?.id || profileData?.id;
      if (!refId) {
        console.log("No refId available for workflow steps");
        return;
      }

      const workflowName = "CONTRACTOR_ONBOARDING";
      const refType = "contractor";
      
      const endpoint = `${Setting.endpoints.workflowSteps(workflowName)}?refId=${refId}&refType=${refType}`;
      
      const response = await getApiData(
        endpoint,
        "GET",
        null,
        { 
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        true // Use new base URL
      );
      
      let steps = [];
      
      // Handle direct array response
      if (Array.isArray(response)) {
        steps = response;
      } 
      // Handle object response with success/data structure
      else if (response && response.success) {
        steps = response.data || [];
      }
      // Handle object response with data but no success flag
      else if (response && response.data && Array.isArray(response.data)) {
        steps = response.data;
      }
      
      // If no steps exist, initialize the workflow for this user
      if (steps.length === 0) {
        await initializeWorkflowIfNeeded(refId);
        return; // initializeWorkflowIfNeeded will call fetchWorkflowSteps again
      }
      
      setWorkflowSteps(steps);
    } catch (error) {
      console.log("❌ Error fetching workflow steps:", error);
    }
  };
  
  // Initialize workflow for existing users who don't have one
  const initializeWorkflowIfNeeded = async (refId) => {
    try {
      const { initiateContractorOnboardingWorkflow, updateStepMappingToCompleted } = await import("../../utils/stepMappingUtils");
      const success = await initiateContractorOnboardingWorkflow(refId, token);
      
      if (success) {
        // Mark CREATE_ACCOUNT as completed since user already has an account
        await updateStepMappingToCompleted(refId, "CREATE_ACCOUNT", token);
        
        // Fetch the steps again after initialization
        const workflowName = "CONTRACTOR_ONBOARDING";
        const refType = "contractor";
        const endpoint = `${Setting.endpoints.workflowSteps(workflowName)}?refId=${refId}&refType=${refType}`;
        
        const response = await getApiData(
          endpoint,
          "GET",
          null,
          { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          true
        );
        
        if (Array.isArray(response)) {
          setWorkflowSteps(response);
        } else if (response?.data) {
          setWorkflowSteps(response.data);
        }
      }
    } catch (error) {
      console.log("❌ Error initializing workflow:", error);
    }
  };

  // Helper function to get step status from workflow data
  const getStepStatus = (stepName) => {
    const step = workflowSteps.find(step => step.stepName === stepName);
    return step ? step.state : 'NOT_STARTED';
  };

  // Helper function to check if step is completed
  const isStepCompleted = (stepName) => {
    const status = getStepStatus(stepName);
    return status === 'COMPLETED';
  };

  // Function to calculate onboarding progress percentage
  const calculateOnboardingProgress = () => {
    const steps = ["CREATE_ACCOUNT", "DOCUMENT_SUBMIT", "PORTFOLIO", "PROFILE"];
    const completedSteps = steps.filter(step => 
      step === "CREATE_ACCOUNT" ? true : isStepCompleted(step)
    );
    const progressPercentage = (completedSteps.length / steps.length) * 100;
    return Math.round(progressPercentage);
  };

  // Function to check if all onboarding steps are completed
  const areAllStepsCompleted = () => {
    const steps = ["CREATE_ACCOUNT", "DOCUMENT_SUBMIT", "PORTFOLIO", "PROFILE"];
    return steps.every(step => 
      step === "CREATE_ACCOUNT" ? true : isStepCompleted(step)
    );
  };

  // Function to handle dismissing the onboarding card
  const handleDismissOnboarding = () => {
    if (userData?.id) {
      dispatch(setOnboardingDismissed(userData.id, true));
      toast.success("Onboarding card dismissed");
    }
  };

  // Function to check if first 3 steps are completed and update PROFILE step
  // DISABLED: This was causing conflicts with manual PROFILE step completion
  // The PROFILE step should only be completed manually by user click
  const checkAndUpdateProfileStep = async () => {
    try {
      const refId = userData?.id || profileData?.id;
      if (!refId || !token) {
        console.log("No refId or token available for profile step update");
        return;
      }

      // Check if the first 3 steps are completed
      const createAccountCompleted = isStepCompleted("CREATE_ACCOUNT");
      const documentSubmitCompleted = isStepCompleted("DOCUMENT_SUBMIT");
      const portfolioCompleted = isStepCompleted("PORTFOLIO");
      const profileCompleted = isStepCompleted("PROFILE");

      // If first 3 steps are completed and PROFILE step is not yet completed
      if (createAccountCompleted && documentSubmitCompleted && portfolioCompleted && !profileCompleted) {
        console.log("First 3 steps completed, updating PROFILE step to completed");
        
        const success = await updateStepMappingToCompleted(refId, "PROFILE", token);
        if (success) {
          console.log("PROFILE step updated to completed successfully");
          // Refresh workflow steps to reflect the update
          await fetchWorkflowSteps();
        } else {
          console.log("Failed to update PROFILE step to completed");
        }
      } else {
        console.log("Profile step check:", {
          createAccountCompleted,
          documentSubmitCompleted,
          portfolioCompleted,
          profileCompleted
        });
      }
    } catch (error) {
      console.log("Error checking and updating profile step:", error);
    }
  };



  // Refresh workflow steps when userData becomes available or changes
  useEffect(() => {
    const refId = userData?.id || profileData?.id;
    if (refId && token) {
      fetchWorkflowSteps();
    }
  }, [userData?.id, profileData?.id, token]); // Re-fetch when user data or token changes

  useEffect(() => {
    if (isEdit) {
      let obj = {};
      obj.lat = data?.lat;
      obj.long = data?.long;
      obj.location = data?.company_address;
      setSelectedLocation(obj);
      setUserLocation(obj?.location);

      const newArray = data?.expertise?.map((item) => item?.project_name);
      const expertiseIdsArray = data?.expertise?.map((item) => item?.id).filter(id => id != null) || [];

      setState({
        ...state,
        businessLogo: profileData?.profile_url,
        cname: data?.company_name || "",
        description: data?.description || "",
        address: obj.location || "",
        email: profileData?.email || "",
        website: data?.website || "",
        pCode: profileData?.phone_code || "",
        phone: profileData?.phone_no || "",
        businessYear: data?.total_years_in_business?.toString() || "",
        employees: data?.company_size?.toString() || "",
        annualContract: data?.no_of_contracts_annually?.toString() || "",
        expertise: newArray || [],
        expertiseIds: expertiseIdsArray,
        certificate: data?.iso_certificate || [],
        license: data?.licenses || [],
        registraion: data?.company_registration || [],
        linkedin: data?.linkedin_url || "",
        social: data?.fb_url || "",
        insta: data?.insta_url || "",
        portfolio: data?.portfolio || "",
        projects_key_locations: data?.projects_key_locations || "",
      });
    }

  }, [profileData]);

  useEffect(() => {
    if (state?.businessLogo && _.isObject(state?.businessLogo)) {
      const imgUrl = URL.createObjectURL(state?.businessLogo);
      setBLogo(imgUrl);
    } else {
      setBLogo(state?.businessLogo || "");
    }
  }, [state?.businessLogo]);

  async function getProjectList() {
    try {
      const response = await getApiData(
        `${Setting.endpoints.expertiseList}`,
        "GET",
        {}
      );
      if (response.success) {
        const matched = response.data.filter(
          (item) => item.type === userData.role
        );
        setExpertiseList(matched.length ? matched : response.data);
      }
    } catch (error) {
    }
  }

  async function getUserDetailsByIdApiCall() {
    setPageLoad(true);
    try {
      const response = await getApiDataWith403Handling(
        Setting.endpoints.me,
        "GET",
        {}
      );
      if (response.success) {
        dispatch(setUserData(response?.data));
        setProfileData(response?.data);
      } else {
        setProfileData(userData);
      }
      setPageLoad(false);
    } catch (error) {
      setProfileData(userData);
      setPageLoad(false);
    }
  }


  const handleLocationChange = (locationObj) => {
    // Store temporarily - don't update state or call API yet
    setTempLocation(locationObj);
  };

  const handleLocationUpdate = async () => {
    if (!tempLocation || !tempLocation?.location || tempLocation.location.trim() === "") {
      toast.error("Please enter a location");
      return;
    }

    // Update state with the new location
    setSelectedLocation(tempLocation);
    setUserLocation(tempLocation.location);
    setState(prev => ({ ...prev, address: tempLocation.location }));

    // Call API with the location data
    const success = await updateContractorDetails({
      company_address: tempLocation.location,
      lat: tempLocation.lat || "",
      long: tempLocation.lng || "",
      city: tempLocation.city || "",
    }, "Location updated successfully");

    if (success) {
      setEditingLocation(false);
      setTempLocation(null);
    }
  };

  const handleLocationCancel = () => {
    setEditingLocation(false);
    setTempLocation(null);
  };

  const updateContractorDetails = async (updates = {}, successMessage = "Details updated successfully") => {
    try {
      setButtonLoader(true);
      
      // Use stored expertise IDs if available, otherwise map names to IDs
      let selectedOptions = [];
      
      // Check if expertise IDs are passed in updates first (for immediate updates)
      if (updates.contractor_expertise !== undefined) {
        // If contractor_expertise is explicitly passed in updates, use it
        selectedOptions = Array.isArray(updates.contractor_expertise) 
          ? updates.contractor_expertise 
          : updates.contractor_expertise.split(',').filter(id => id.trim() !== '');
      } else if (state?.expertiseIds && state.expertiseIds.length > 0) {
        // Use the IDs directly from the modal
        selectedOptions = state.expertiseIds;
      } else if (state?.expertise && state.expertise.length > 0) {
        // Fallback: map names to IDs if IDs are not available
        state.expertise.forEach((expertiseName) => {
          const found = expertiseList.find((option) => option?.project_name === expertiseName);
          if (found && found.id) {
            selectedOptions.push(found.id);
          }
        });
      }

      let contractorExpertise = "0";
      if (updates.contractor_expertise !== undefined) {
        // If contractor_expertise is explicitly passed in updates, use it
        if (Array.isArray(updates.contractor_expertise)) {
          contractorExpertise = updates.contractor_expertise.length > 0 
            ? updates.contractor_expertise.join(",") 
            : "0";
        } else {
          contractorExpertise = updates.contractor_expertise && updates.contractor_expertise.trim() !== "" 
            ? updates.contractor_expertise 
            : "0";
        }
      } else if (selectedOptions.length > 0) {
        contractorExpertise = selectedOptions.join(",");
      } else {
        contractorExpertise = "0";
      }

      const { contractor_expertise: _, ...otherUpdates } = updates;

      let data = {
        company_name: state?.cname ? state?.cname : "",
        description: state?.description ? state?.description : "",
        company_address: updates?.company_address !== undefined ? updates.company_address : (userLocation || ""),
        website: state?.website || "",
        total_years_in_business: state?.businessYear || "1-3 years",
        company_size: state?.employees || "1-10 employees",
        no_of_contracts_annually: state?.annualContract ? state?.annualContract : "",
        contractor_expertise: contractorExpertise, // Always include, even if empty string
        linkedin_url: state?.linkedin || "",
        fb_url: state?.social || "",
        insta_url: state?.insta || "",
        lat: updates?.lat !== undefined ? updates.lat : (selectedLocation?.lat || ""),
        long: updates?.long !== undefined ? updates.long : (selectedLocation?.long || ""),
        city: updates?.city !== undefined ? updates.city : (selectedLocation?.city || ""),
        type: "contractor",
        projects_key_locations: state?.projects_key_locations || "",
        ...otherUpdates, // Spread other updates (excluding contractor_expertise)
        // Ensure contractor_expertise is always included, even if empty
        contractor_expertise: contractorExpertise
      };
      
      const response = await getAPIProgressData(
        Setting.endpoints.addContractorDetails,
        "POST",
        data,
        true
      );
      
      if (response.success) {
        dispatch(setUserData(response?.data));
        toast.success(successMessage);
        return true;
      } else {
        toast.error(response.message);
        return false;
      }
    } catch (error) {
      toast.error(error.toString());
      return false;
    } finally {
      setButtonLoader(false);
    }
  };

  async function handleDeleteImage() {
    setDeleteImg({ ...deleteImg, loader: true });
    try {
      const response = await getApiData(
        `${Setting.endpoints.deleteImage}/${deleteImg.id}`,
        "GET"
      );

      if (response.success) {
        const data = [...state[deleteImg.type]];
        data.splice(deleteImg?.index, 1);
        if (deleteImg?.type === "certificate") {
          setState({ ...state, certificate: data });
        } else if (deleteImg?.type === "license") {
          setState({ ...state, license: data });
        } else if (deleteImg?.type === "registraion") {
          setState({ ...state, registraion: data });
        }
        setDeleteImg({
          visible: false,
          id: null,
          index: null,
          type: "",
          loader: false,
        });
        toast.success(response.message);
      } else {
        toast.error(response.message);
        setDeleteImg({ ...deleteImg, loader: false });
      }
    } catch (error) {
      toast.error(error.toString());
      setDeleteImg({ ...deleteImg, loader: false });
    }
  }

  const handleAddExpertise = (selectedItems) => {
    setState((prev) => ({
      ...prev,
      expertise: Array.isArray(prev.expertise)
        ? [...new Set([...prev.expertise, ...selectedItems])]
        : selectedItems,
    }));
    setErrObj({
      ...errObj,
      expertiseErr: false,
      expertiseMsg: "",
    });
  };

  const handleRemoveExpertise = async (item) => {
    const updatedExpertise = state.expertise.filter((exp) => exp !== item);
    // Find and remove the corresponding ID
    const expertiseItem = expertiseList.find((exp) => exp.project_name === item);
    const updatedExpertiseIds = expertiseItem && expertiseItem.id
      ? state.expertiseIds.filter((id) => id !== expertiseItem.id)
      : state.expertiseIds;
    
    // Update state immediately
    setState((prev) => ({
      ...prev,
      expertise: updatedExpertise,
      expertiseIds: updatedExpertiseIds,
    }));
    setErrObj({
      ...errObj,
      expertiseErr: false,
      expertiseMsg: "",
    });

    // Pass updated expertise IDs directly to avoid async state issue
    // If empty array, it will be converted to empty string "" which is correct
    const success = await updateContractorDetails(
      { contractor_expertise: updatedExpertiseIds }, 
      "Expertise area removed successfully"
    );
    
    // Don't refresh profile data after removal - it might repopulate with old expertise
    // The state is already updated, so the UI will reflect the change
  };

  const handleExpertiseSave = async (expertiseIds, selectedExpertise) => {
    const expertiseNames = selectedExpertise.map(item => item.project_name);
    
    // Update state
    setState(prev => ({
      ...prev,
      expertise: expertiseNames,
      expertiseIds: expertiseIds
    }));

    // Pass expertise IDs directly in updates to avoid async state issue
    const success = await updateContractorDetails(
      { contractor_expertise: expertiseIds }, 
      "Expertise areas updated successfully"
    );
    
    if (success) {
      setErrObj({
        ...errObj,
        expertiseErr: false,
        expertiseMsg: "",
      });
      // Refresh profile data after successful update to get latest from API
      await getUserDetailsByIdApiCall();
    }
  };


  return (
    <Box sx={{ padding: "20px", backgroundColor: "#fff", minHeight: "100vh" }}>
      {pageLoad ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress style={{ color: color.primary }} size={30} />
        </div>
      ) : (
        <>
          <Grid container spacing={3}>
          <Grid item xs={12} md={8}>

            {/* Getting Started Card - Only show if not dismissed and not all steps completed */}
            {!onboardingDismissed && !areAllStepsCompleted() && (
            <Card sx={{ mb: 3, borderRadius: '16px', border: 'none', boxShadow: 'none', backgroundColor: '#F7F7F7' }}>
              <CardContent sx={{ py: 3, px: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 2, fontSize: "16px" }}>
                  Getting started
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 500, mb: 3, color: "#333", fontSize: "28px" }}>
                  Get verified and join our elite network of {userData?.role === "designer" ? "designers" : userData?.role === "supplier" ? "suppliers" : "contractors"}
                </Typography>
                
                <Box sx={{ position: "relative", mb: 3 }}>
                  <LinearProgress
                    variant="determinate"
                    value={calculateOnboardingProgress()}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "#E5E7EB",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#4D6BF6",
                      },
                    }}
                  />
                  
                  <Box sx={{ 
                    position: "absolute", 
                    top: "50%", 
                    left: 0, 
                    right: 0, 
                    transform: "translateY(-50%)",
                    height: 16,
                  }}>
                    {[
                      { step: "START", completed: true },
                      { step: "CREATE_ACCOUNT", completed: true }, // Always completed - user has created account
                      { step: "DOCUMENT_SUBMIT", completed: isStepCompleted("DOCUMENT_SUBMIT") },
                      { step: "PORTFOLIO", completed: isStepCompleted("PORTFOLIO") },
                      { step: "PROFILE", completed: isStepCompleted("PROFILE") }
                    ].map((stepData, index) => (
                      <Box
                        key={stepData.step}
                        sx={{
                          width: 16,
                          height: 16,
                          borderRadius: "50%",
                          backgroundColor: "white",
                          border: "2px solid #4D6BF6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          zIndex: 1,
                          left: index === 0 ? 0 : index === 4 ? "calc(100% - 16px)" : `${(index / 4) * 100}%`,
                          transform: index === 0 ? "translateX(0)" : index === 4 ? "translateX(0)" : "translateX(-50%)",
                        }}
                      >
                        {stepData.completed && (
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor: "#4D6BF6",
                            }}
                          />
                        )}
                      </Box>
                    ))}
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  {/* Create Account - Always shown as completed since user has already created their account */}
                  <Box 
                    sx={{ 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 2, 
                      cursor: "default"
                    }}
                  >
                    <CheckCircle sx={{ color: "#10B981", fontSize: 20 }} />
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: "#666",
                        textDecoration: "line-through",
                        fontWeight: 700,
                        fontSize: "16px"
                      }}
                    >
                      Create account
                    </Typography>
                  </Box>
                  
                  {/* Submit Documents - Navigate to Documents tab */}
                  <Box 
                    sx={{ 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 2, 
                      cursor: isStepCompleted("DOCUMENT_SUBMIT") ? "default" : "pointer"
                    }}
                    onClick={() => {
                      if (!isStepCompleted("DOCUMENT_SUBMIT")) {
                        onTabChange(1);
                      }
                    }}
                  >
                    {isStepCompleted("DOCUMENT_SUBMIT") ? (
                      <CheckCircle sx={{ color: "#10B981", fontSize: 20 }} />
                    ) : (
                      <RadioButtonUnchecked sx={{ color: "#9CA3AF", fontSize: 20 }} />
                    )}
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: isStepCompleted("DOCUMENT_SUBMIT") ? "#666" : "#333",
                        textDecoration: isStepCompleted("DOCUMENT_SUBMIT") ? "line-through" : "none",
                        fontWeight: 700,
                        fontSize: "16px"
                      }}
                    >
                      Submit documents
                    </Typography>
                    {!isStepCompleted("DOCUMENT_SUBMIT") && (
                      <Typography sx={{ color: "#9CA3AF", fontSize: 24, ml: "auto" }}>›</Typography>
                    )}
                  </Box>
                  
                  {/* Publish Portfolio - Navigate to Portfolio tab */}
                  <Box 
                    sx={{ 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 2, 
                      cursor: isStepCompleted("PORTFOLIO") ? "default" : "pointer"
                    }}
                    onClick={() => {
                      if (!isStepCompleted("PORTFOLIO")) {
                        onTabChange(2);
                      }
                    }}
                  >
                    {isStepCompleted("PORTFOLIO") ? (
                      <CheckCircle sx={{ color: "#10B981", fontSize: 20 }} />
                    ) : (
                      <RadioButtonUnchecked sx={{ color: "#9CA3AF", fontSize: 20 }} />
                    )}
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: isStepCompleted("PORTFOLIO") ? "#666" : "#333",
                        textDecoration: isStepCompleted("PORTFOLIO") ? "line-through" : "none",
                        fontWeight: 700,
                        fontSize: "16px"
                      }}
                    >
                      Publish portfolio
                    </Typography>
                    {!isStepCompleted("PORTFOLIO") && (
                      <Typography sx={{ color: "#9CA3AF", fontSize: 24, ml: "auto" }}>›</Typography>
                    )}
                  </Box>
                  
                  <Box 
                    sx={{ 
                      display: "flex", 
                      alignItems: "center", 
                      gap: 2, 
                      cursor: isStepCompleted("PROFILE") || isUpdatingProfile ? "default" : "pointer"
                    }}
                    onClick={async () => {
                      if (!isStepCompleted("PROFILE") && !isUpdatingProfile) {
                        setIsUpdatingProfile(true);
                        try {
                          const refId = userData?.id || profileData?.id;
                          if (!refId || !token) {
                            console.log("No refId or token available for profile step update");
                            toast.error("Unable to complete profile step");
                            return;
                          }
                          
                          console.log("=== MANUAL PROFILE STEP UPDATE ===");
                          console.log("refId:", refId);
                          console.log("token exists:", !!token);
                          console.log("Current PROFILE step status:", getStepStatus("PROFILE"));
                          
                          const success = await updateStepMappingToCompleted(refId, "PROFILE", token);
                          console.log("API call result:", success);
                          console.log("Result type:", typeof success);
                          
                          if (success) {
                            console.log("SUCCESS: Profile step updated");
                            toast.success("Profile step completed successfully!");
                            // Refresh workflow steps to reflect the update
                            await fetchWorkflowSteps();
                            console.log("Workflow steps refreshed");
                          } else {
                            console.log("FAILED: Profile step not updated");
                            console.log("Success value:", success);
                            toast.error("Failed to complete profile step");
                          }
                        } catch (error) {
                          console.log("Error updating PROFILE step:", error);
                          toast.error("Error completing profile step");
                        } finally {
                          setIsUpdatingProfile(false);
                        }
                      }
                    }}
                  >
                    {isUpdatingProfile ? (
                      <CircularProgress size={20} sx={{ color: "#4D6BF6" }} />
                    ) : isStepCompleted("PROFILE") ? (
                      <CheckCircle sx={{ color: "#10B981", fontSize: 20 }} />
                    ) : (
                      <RadioButtonUnchecked sx={{ color: "#9CA3AF", fontSize: 20 }} />
                    )}
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: isStepCompleted("PROFILE") ? "#666" : "#333",
                        textDecoration: isStepCompleted("PROFILE") ? "line-through" : "none",
                        fontWeight: 700,
                        fontSize: "16px"
                      }}
                    >
                      Complete your profile
                    </Typography>
                    {!isStepCompleted("PROFILE") && !isUpdatingProfile && (
                      <Typography sx={{ color: "#9CA3AF", fontSize: 24, ml: "auto" }}>›</Typography>
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Card>
            )}

{/* Completion Message - Show when all steps are completed */}
            {areAllStepsCompleted() && !onboardingDismissed && (
              <Card sx={{ mb: 3, borderRadius: 2, border: 'none', boxShadow: 'none', backgroundColor: '#F0F9FF' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 500, mb: 1, fontSize: "18px", color: '#059669' }}>
                        🎉 Congratulations! You've completed your onboarding!
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6B7280', fontSize: "14px" }}>
                        You're now part of our elite network of contractors. Your profile is complete and ready to receive project opportunities.
                      </Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleDismissOnboarding}
                      sx={{ 
                        color: '#059669', 
                        borderColor: '#059669',
                        fontSize: '12px',
                        textTransform: 'none',
                        ml: 2
                      }}
                    >
                      Dismiss
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            )}

            {/* Company Overview */}
            <Card sx={{ mb: 3, borderRadius: 2, border: 'none', boxShadow: 'none' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h3" sx={{ fontWeight: 500, mb: 2, fontSize: "20px" }}>
                  Company overview
                </Typography>
                {editingDescription && !readOnly ? (
                  <Box>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      value={tempDescription}
                      onChange={(e) => setTempDescription(e.target.value)}
                      placeholder="Enter your company description..."
                      variant="outlined"
                      sx={{
                        mb: 2,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        }
                      }}
                      autoFocus
                    />
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={async () => {
                          const trimmedDescription = tempDescription.trim();
                          setState(prev => ({ ...prev, description: trimmedDescription }));
                          const success = await updateContractorDetails(
                            { description: trimmedDescription }, 
                            "Description updated successfully"
                          );
                          if (success) {
                            setEditingDescription(false);
                          }
                        }}
                        disabled={buttonLoader}
                        sx={{ 
                          backgroundColor: "#4D6BF6",
                          textTransform: "none",
                          borderRadius: 2
                        }}
                      >
                        {buttonLoader ? "Saving..." : "Save"}
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          setTempDescription(state.description || "");
                          setEditingDescription(false);
                        }}
                        sx={{ 
                          textTransform: "none",
                          borderRadius: 2
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    {state.description ? (
                      <>
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            color: "#666", 
                            mb: 2, 
                            lineHeight: 1.6,
                            cursor: readOnly ? "default" : "pointer",
                            "&:hover": readOnly ? {} : {
                              backgroundColor: "#F9FAFB",
                              borderRadius: 1,
                              p: 1,
                              mt: -1,
                              mb: 1
                            }
                          }}
                          onClick={readOnly ? undefined : () => {
                            setTempDescription(state.description);
                            setEditingDescription(true);
                          }}
                        >
                          {state.description}
                        </Typography>
                        {!readOnly && (
                          <Button
                            variant="text"
                            sx={{ color: "#4D6BF6", textTransform: "none", p: 0, boxShadow: "none" }}
                            onClick={() => {
                              setTempDescription(state.description);
                              setEditingDescription(true);
                            }}
                          >
                            Edit
                          </Button>
                        )}
                      </>
                    ) : (
                      <>
                        <Typography variant="body1" sx={{ color: "#999", mb: 2, lineHeight: 1.6, fontStyle: "italic" }}>
                          No company description added yet.
                        </Typography>
                        {!readOnly && (
                          <Button
                            variant="text"
                            sx={{ color: "#4D6BF6", textTransform: "none", p: 0, border: "none", boxShadow: "none" }}
                            onClick={() => {
                              setTempDescription("");
                              setEditingDescription(true);
                            }}
                          >
                            + Add yours
                          </Button>
                        )}
                      </>
                    )}
                  </Box>
                )}
              </CardContent>
            </Card>

            {/* Areas of Expertise */}
            <Card sx={{ mb: 3, borderRadius: 2, border: 'none', boxShadow: 'none' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h3" sx={{ fontWeight: 500, mb: 2, fontSize: "20px" }}>
                  Areas of expertise
                </Typography>
                <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                  {state.expertise && state.expertise.length > 0 && (
                    state.expertise.map((item, index) => (
                      <Chip
                        key={index}
                        label={item}
                        onDelete={readOnly ? undefined : () => handleRemoveExpertise(item)}
                        sx={{
                          backgroundColor: "#F3F4F6",
                          color: "#374151",
                          borderRadius: 3,
                          height: 32,
                          minWidth: 80,
                          "& .MuiChip-label": {
                            px: 2
                          },
                          "& .MuiChip-deleteIcon": readOnly ? { display: "none" } : {
                            color: "#6B7280",
                            fontSize: 18,
                            "&:hover": {
                              color: "#EF4444"
                            }
                          }
                        }}
                      />
                    ))
                  )}
                  {!readOnly && (
                    <Button
                      variant="text"
                      onClick={() => setExpertiseModalOpen(true)}
                      sx={{ 
                        color: "#4D6BF6", 
                        textTransform: "none", 
                        borderRadius: 3,
                        height: 32,
                        minWidth: 80,
                        px: 2,
                        border: "none",
                        backgroundColor: "#F3F4F6",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#F9FAFB"
                        }
                      }}
                    >
                      + Add a new area
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Card>

            {/* Portfolio Section */}
            <Card sx={{ mb: 3, borderRadius: 2, border: 'none', boxShadow: 'none' }}>
              <CardContent sx={{ p: 0 }}>
                <PortfolioPreview />
              </CardContent>
            </Card>
          </Grid>

          {/* Right Sidebar */}
          <Grid item xs={12} md={4}>
            {/* Contact Details */}
            <Card sx={{ mb: 3, borderRadius: 2, border: "none", boxShadow: "none" }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 2 }}>
                  Contact Details
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="body1" sx={{ color: "#9CA3AF", fontSize: "16px", display: "inline" }}>
                    Email
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#000", fontSize: "16px", display: "inline", ml: 6 }}>
                    {state.email}
                  </Typography>
                </Box>
                {(userData?.phone_code || userData?.phone_no || state.phone) && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body1" sx={{ color: "#9CA3AF", fontSize: "16px", display: "inline" }}>
                      Phone
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#000", fontSize: "16px", display: "inline", ml: 6 }}>
                      {userData?.phone_code ? `(${userData.phone_code}) ${userData.phone_no || state.phone}` : state.phone}
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>

            {/* Location */}
            <Card sx={{ mb: 3, borderRadius: 2, border: "none", boxShadow: "none" }}>
              <CardContent sx={{ p: 3, borderRadius: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 2 }}>
                  Location
                </Typography>
                {editingLocation && !readOnly ? (
                  <Box sx={{ mb: 2 }}>
                    <PlaceAutoComplete
                      placeholder="Enter your office location"
                      style={{ marginBottom: 10, width: "100%" }}
                      onChange={handleLocationChange}
                      defaultValue={userLocation || data?.company_address}
                    />
                    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleLocationCancel}
                        disabled={buttonLoader}
                        sx={{ 
                          textTransform: "none",
                          borderRadius: 2
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleLocationUpdate}
                        disabled={buttonLoader || !tempLocation || !tempLocation?.location || tempLocation.location.trim() === ""}
                        sx={{ 
                          textTransform: "none",
                          borderRadius: 2,
                          backgroundColor: "#4D6BF6",
                          "&:hover": {
                            backgroundColor: "#3B5AE5",
                          }
                        }}
                      >
                        {buttonLoader ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CircularProgress size={16} sx={{ color: "white" }} />
                            Updating...
                          </Box>
                        ) : (
                          "Update"
                        )}
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2, backgroundColor: "#F7F7F7", padding: 2 }}>
                    {/* Left side - Address and Edit link */}
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body2" sx={{ color: "#000", mb: 1 }}>
                        {userLocation || data?.company_address || "No location specified"}
                      </Typography>
                      {data?.city && (
                        <Typography variant="caption" sx={{ color: "#666", fontSize: "0.75rem", display: "block", mb: 0.5 }}>
                          City: {data.city}
                        </Typography>
                      )}
                      {!readOnly && (
                        <Button
                          variant="text"
                          onClick={() => {
                            // Initialize tempLocation with current location when starting to edit
                            setTempLocation({
                              location: userLocation || data?.company_address || "",
                              lat: selectedLocation?.lat || "",
                              lng: selectedLocation?.long || "",
                              city: selectedLocation?.city || "",
                            });
                            setEditingLocation(true);
                          }}
                          sx={{ 
                            color: "#4D6BF6", 
                            textTransform: "none", 
                            p: 0,
                            fontSize: "0.875rem",
                            minWidth: "auto",
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            "&:hover": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "&:focus": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "&:active": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            }
                          }}
                        >
                          Edit location
                        </Button>
                      )}
                    </Box>
                  
                  {/* Right side - Interactive Map */}
                  <Box
                    sx={{
                      width: 200,
                      height: 120,
                      borderRadius: 1.5,
                      overflow: "hidden",
                      border: "none",
                    }}
                  >
                    {(data?.lat && data?.long) ? (
                      <MapsView
                        details={{ lat: data.lat, lng: data.long }}
                        mapContainerStyle={{
                          width: "100%",
                          height: "100%",
                        }}
                        interactive={false}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#F3F4F6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <LocationOn sx={{ color: "#9CA3AF", fontSize: 24 }} />
                        <Typography variant="caption" sx={{ color: "#6B7280", textAlign: "center" }}>
                          No location data
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  </Box>
                )}
              </CardContent>
            </Card>

            {/* Socials */}
            <Card sx={{ mb: 3, borderRadius: 2, border: '1px solid #E5E7EB', boxShadow: 'none' }}>
              <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    Socials
                  </Typography>
                  {(!state.linkedin && !state.social && !state.insta) && !readOnly && (
                    <Button
                      variant="outlined"
                      onClick={() => setSocialModalOpen(true)}
                      sx={{
                        border: "none",
                        color: "#000",
                        backgroundColor: "#F5F5F5",
                        borderRadius: 2,
                        textTransform: "none",
                        px: 3,
                        py: 1,
                        "&:hover": {
                          backgroundColor: "#E5E5E5",
                          border: "none",
                        },
                      }}
                    >
                      Connect
                    </Button>
                  )}
                </Box>

                {/* Connected Social Profiles */}
                {(state.linkedin || state.social || state.insta) && (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {/* LinkedIn */}
                    {state.linkedin && (
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, border: "none", borderRadius: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: 2,
                              backgroundColor: "#0077B5",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LinkedIn sx={{ color: "white", fontSize: 24 }} />
                          </Box>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              LinkedIn
                            </Typography>
                            <Typography 
                              variant="body2" 
                              sx={{ color: "#4D6BF6", cursor: "pointer" }}
                              onClick={() => window.open(state.linkedin, '_blank')}
                            >
                              Visit Page <OpenInNew sx={{ fontSize: 16, ml: 0.5 }} />
                            </Typography>
                          </Box>
                        </Box>
                        {!readOnly && (
                          <IconButton
                            onClick={async () => {
                              setState(prev => ({ ...prev, linkedin: "" }));
                              await updateContractorDetails({ linkedin_url: "" }, "LinkedIn profile removed successfully");
                            }}
                            sx={{
                              backgroundColor: '#F3F4F6',
                              width: 32,
                              height: 32,
                              border: '1px solid #E5E7EB',
                              borderRadius: '5px',
                              padding: '4px',
                              '&:hover': {
                                backgroundColor: '#FEE2E2',
                              }
                            }}
                          >
                            <img 
                              src="/assets/images/trash_icon.png" 
                              alt="Delete" 
                              style={{ width: '24px', height: '24px' }}
                            />
                          </IconButton>
                        )}
                      </Box>
                    )}

                    {/* Instagram */}
                    {state.insta && (
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, border: "none", borderRadius: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: 2,
                              background: "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Instagram sx={{ color: "white", fontSize: 24 }} />
                          </Box>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              Instagram
                            </Typography>
                            <Typography 
                              variant="body2" 
                              sx={{ color: "#4D6BF6", cursor: "pointer" }}
                              onClick={() => window.open(state.insta, '_blank')}
                            >
                              Visit Page <OpenInNew sx={{ fontSize: 16, ml: 0.5 }} />
                            </Typography>
                          </Box>
                        </Box>
                        {!readOnly && (
                          <IconButton
                            onClick={async () => {
                              setState(prev => ({ ...prev, insta: "" }));
                              await updateContractorDetails({ insta_url: "" }, "Instagram profile removed successfully");
                            }}
                            sx={{
                              backgroundColor: '#F3F4F6',
                              width: 32,
                              height: 32,
                              border: '1px solid #E5E7EB',
                              borderRadius: '5px',
                              padding: '4px',
                              '&:hover': {
                                backgroundColor: '#FEE2E2',
                              }
                            }}
                          >
                            <img 
                              src="/assets/images/trash_icon.png" 
                              alt="Delete" 
                              style={{ width: '24px', height: '24px' }}
                            />
                          </IconButton>
                        )}
                      </Box>
                    )}

                    {/* Facebook */}
                    {state.social && (
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, border: "none", borderRadius: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: 2,
                              backgroundColor: "#1877F2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Facebook sx={{ color: "white", fontSize: 24 }} />
                          </Box>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              Facebook
                            </Typography>
                            <Typography 
                              variant="body2" 
                              sx={{ color: "#4D6BF6", cursor: "pointer" }}
                              onClick={() => window.open(state.social, '_blank')}
                            >
                              Visit Page <OpenInNew sx={{ fontSize: 16, ml: 0.5 }} />
                            </Typography>
                          </Box>
                        </Box>
                        {!readOnly && (
                          <IconButton
                            onClick={async () => {
                              setState(prev => ({ ...prev, social: "" }));
                              await updateContractorDetails({ fb_url: "" }, "Facebook profile removed successfully");
                            }}
                            sx={{
                              backgroundColor: '#F3F4F6',
                              width: 32,
                              height: 32,
                              border: '1px solid #E5E7EB',
                              borderRadius: '5px',
                              padding: '4px',
                              '&:hover': {
                                backgroundColor: '#FEE2E2',
                              }
                            }}
                          >
                            <img 
                              src="/assets/images/trash_icon.png" 
                              alt="Delete" 
                              style={{ width: '24px', height: '24px' }}
                            />
                          </IconButton>
                        )}
                      </Box>
                    )}

                    {/* Add More Button */}
                    {!readOnly && (
                      <Button
                        variant="outlined"
                        startIcon={<Link />}
                        onClick={() => setSocialModalOpen(true)}
                        sx={{
                          border: "none",
                          color: "#4D6BF6",
                          backgroundColor: "white",
                          borderRadius: 2,
                          textTransform: "none",
                          px: 3,
                          py: 1,
                          mt: 1,
                          "&:hover": {
                            backgroundColor: "#F8FAFF",
                            border: "none",
                          },
                        }}
                      >
                        Add More
                      </Button>
                    )}
                  </Box>
                )}

                {/* No Socials Connected - Show Connect Button */}
                {(!state.linkedin && !state.social && !state.insta) && (
                  <>
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* Facebook */}
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            backgroundColor: "#1877F2",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            zIndex: 3,
                          }}
                        >
                          <Facebook sx={{ color: "white", fontSize: 30 }} />
                        </Box>
                        {/* LinkedIn */}
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            backgroundColor: "#0077B5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            zIndex: 2,
                            ml: "-3px",
                          }}
                        >
                          <LinkedIn sx={{ color: "white", fontSize: 30 }} />
                        </Box>
                        {/* Instagram */}
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            background: "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            zIndex: 1,
                            ml: "-3px",
                          }}
                        >
                          <Instagram sx={{ color: "white", fontSize: 30 }} />
                        </Box>
                      </Box>
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 500, mb: 1, textAlign: "center" }}>
                      Connect your socials
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666", mb: 2, textAlign: "center" }}>
                      Let clients see your work in action
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                      <Button
                        variant="outlined"
                        startIcon={<Link />}
                        onClick={() => setSocialModalOpen(true)}
                        sx={{
                          border: "none",
                          color: "#000",
                          backgroundColor: "#F5F5F5",
                          borderRadius: 2,
                          textTransform: "none",
                          px: 3,
                          py: 1,
                          "&:hover": {
                            backgroundColor: "#E5E5E5",
                            border: "none",
                          },
                        }}
                      >
                        Connect
                      </Button>
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>

            {/* Billing */}
            <Card sx={{ mb: 3, borderRadius: 2, border: '1px solid #E5E7EB', boxShadow: 'none' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, mb: 2 }}>
                  Billing
                </Typography>
                
                {(() => {
                  const billingInfo = userData?.contractor_data?.billing_info;
                  const hasBillingInfo = billingInfo && (
                    billingInfo.beneficiary_name ||
                    billingInfo.iban ||
                    billingInfo.bank_name ||
                    billingInfo.bank_account ||
                    billingInfo.swift_code ||
                    billingInfo.address
                  );
                  
                  return hasBillingInfo ? (
                    // Show bank icon and edit CTA when billing info exists
                    <>
                      <Box
                        sx={{
                          height: 80,
                          borderRadius: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2,
                          backgroundColor: "#F8F9FA",
                          border: "1px solid #E5E7EB",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src="/assets/images/billing.jpg"
                          alt="Billing"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                      {!readOnly && (
                        <Button
                          variant="contained"
                          startIcon={<Edit />}
                          onClick={() => setBillingModalOpen(true)}
                          sx={{
                            backgroundColor: "#4D6BF6",
                            borderRadius: 2,
                            textTransform: "none",
                            width: "100%",
                            py: 1.5,
                          }}
                        >
                          Edit Billing Information
                        </Button>
                      )}
                    </>
                  ) : (
                  // Show add billing info when no billing info exists
                  <>
                    <Box
                      sx={{
                        height: 60,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src="/assets/images/billing_chart.png"
                        alt="Payment activity chart"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                    <Typography variant="h6" sx={{ fontWeight: 500, mb: 1 }}>
                      Add your billing details
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
                      Enter your billing information to enable fast, secure payments for every project.
                    </Typography>
                    {!readOnly && (
                      <Button
                        variant="contained"
                        onClick={() => setBillingModalOpen(true)}
                        sx={{
                          backgroundColor: "#4D6BF6",
                          borderRadius: 2,
                          textTransform: "none",
                          width: "100%",
                        }}
                      >
                        Add billing information
                      </Button>
                    )}
                  </>
                  );
                })()}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        </>
      )}
      <ConfirmModel
        visible={deleteImg?.visible}
        handleClose={() =>
          setDeleteImg({
            visible: false,
            id: null,
            index: null,
            type: "",
            loader: false,
          })
        }
        loader={deleteImg?.loader}
        confirmation={() => {
          handleDeleteImage();
        }}
        message={`Are you sure you want to delete?`}
      />
      
      <SocialProfilesModal
        open={socialModalOpen}
        onClose={() => setSocialModalOpen(false)}
        onSave={async (socialLinks) => {
          // Update the state with the new social links
          setState(prev => ({
            ...prev,
            linkedin: socialLinks.linkedin || "",
            social: socialLinks.facebook || "", // Using facebook for fb_url as per existing structure
            insta: socialLinks.instagram || "",
          }));
          
          // Call API with the updated social links - pass the new values directly
          await updateContractorDetails({
            linkedin_url: socialLinks.linkedin || "",
            fb_url: socialLinks.facebook || "",
            insta_url: socialLinks.instagram || "",
          }, "Social profiles connected successfully!");
        }}
        initialData={{
          linkedin: state.linkedin || "",
          instagram: state.insta || "",
          facebook: state.social || "",
        }}
      />
      
      <BillingInformationModal
        open={billingModalOpen}
        onClose={() => setBillingModalOpen(false)}
        onSave={async (billingData) => {
          // Billing data is already saved via API in the modal
          // Refresh user data to update the UI
          await getUserDetailsByIdApiCall();
        }}
        initialData={{
          beneficiaryName: userData?.contractor_data?.billing_info?.beneficiary_name || "",
          iban: userData?.contractor_data?.billing_info?.iban || "",
          bankName: userData?.contractor_data?.billing_info?.bank_name || "",
          bankAccount: userData?.contractor_data?.billing_info?.bank_account || "",
          swiftCode: userData?.contractor_data?.billing_info?.swift_code || "",
          address: userData?.contractor_data?.billing_info?.address || "",
        }}
      />
      
      <ExpertiseSelectionModal
        open={expertiseModalOpen}
        onClose={() => setExpertiseModalOpen(false)}
        onSave={handleExpertiseSave}
        initialSelected={state.expertise?.map(name => {
          const expertise = expertiseList.find(item => item.project_name === name);
          return expertise || { id: null, project_name: name };
        }).filter(item => item.id) || []}
        userRole={userData?.role}
      />
    </Box>
  );
}